export const checkCounterHasExpired = () => {
    return new Date() >= new Date("2025-10-01T00:00:00");
}
